import { useCallback, useEffect, useRef, useState } from 'react';

const CLE = 'klarys_fenetre';
const DEFAUT = { flottant: false, x: null, y: 80, w: 760, h: 640 };

const lire = () => {
  try { return { ...DEFAUT, ...JSON.parse(localStorage.getItem(CLE) || '{}') }; } catch { return DEFAUT; }
};

// Fenêtre flottante Klarys : position (glisser l'en-tête) et taille (poignée native) mémorisées.
export function useKlarysFenetre() {
  const [g, setG] = useState(lire);
  const ref = useRef(null);
  const sauver = useCallback((maj) => setG((prev) => {
    const n = { ...prev, ...maj };
    localStorage.setItem(CLE, JSON.stringify(n));
    return n;
  }), []);

  useEffect(() => {
    if (!g.flottant || !ref.current || typeof ResizeObserver === 'undefined') return undefined;
    let t;
    const ro = new ResizeObserver(([e]) => {
      clearTimeout(t);
      t = setTimeout(() => sauver({ w: Math.round(e.contentRect.width), h: Math.round(e.contentRect.height) }), 300);
    });
    ro.observe(ref.current);
    return () => { clearTimeout(t); ro.disconnect(); };
  }, [g.flottant, sauver]);

  const glisser = (e) => {
    if (!g.flottant || e.button !== 0 || e.target.closest('button, nav, a, input')) return;
    const r = ref.current.getBoundingClientRect();
    const dx = e.clientX - r.left, dy = e.clientY - r.top;
    const bouger = (m) => {
      ref.current.style.left = `${Math.max(0, Math.min(window.innerWidth - 120, m.clientX - dx))}px`;
      ref.current.style.top = `${Math.max(0, Math.min(window.innerHeight - 60, m.clientY - dy))}px`;
    };
    const fin = () => {
      window.removeEventListener('mousemove', bouger);
      window.removeEventListener('mouseup', fin);
      const f = ref.current.getBoundingClientRect();
      sauver({ x: Math.round(f.left), y: Math.round(f.top) });
    };
    window.addEventListener('mousemove', bouger);
    window.addEventListener('mouseup', fin);
  };

  const style = g.flottant ? {
    left: g.x ?? Math.max(16, window.innerWidth - g.w - 32), top: g.y, width: g.w, height: g.h,
    resize: 'both', minWidth: 520, minHeight: 360, maxWidth: '96vw', maxHeight: '94vh', overflow: 'hidden',
  } : undefined;
  const classe = g.flottant
    ? 'fixed z-[60] flex flex-col rounded-xl border border-slate-300 bg-white shadow-2xl'
    : 'fixed inset-y-0 right-0 z-[60] flex w-full max-w-[860px] flex-col border-l border-slate-200 bg-white shadow-2xl';
  return { flottant: g.flottant, basculer: () => sauver({ flottant: !g.flottant }), ref, style, classe, glisser };
}
